import { createClient } from 'contentful'
import { contentfulConfig } from '../../config'
import { mutate } from './mutate'

const contentfulClient = createClient(contentfulConfig)

/*
https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/
*/

export const requestVideo = (id, params, callback) => {
  let query = {
    content_type: 'video',
  }

  if (params) {
    query = Object.assign(query, params)
  }

  contentfulClient.getEntry(id, query)
    .then((entry) => {
      if (callback) {
        const mutatedEntry = mutate(entry)

        callback(mutatedEntry)
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

export const requestVideos = (params, callback) => {
  let query = {
    content_type: 'video',
  }

  if (params) {
    query = Object.assign(query, params)
  }

  contentfulClient.getEntries(query)
    .then((entries) => {
      if (callback) {
        const mutatedEntries = mutate(entries.items)

        callback(mutatedEntries)
      }
    })
    .catch((error) => {
      console.log(error)
    })
}



// WEBPACK FOOTER //
// ./src/common/contentful/lib/requests.js